import { render, staticRenderFns } from "./UserGradeManage.vue?vue&type=template&id=6c1bdbbf&scoped=true&"
import script from "./UserGradeManage.vue?vue&type=script&lang=js&"
export * from "./UserGradeManage.vue?vue&type=script&lang=js&"
import style0 from "./UserGradeManage.vue?vue&type=style&index=0&id=6c1bdbbf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1bdbbf",
  null
  
)

export default component.exports